<section class="activity">
    <div class="left-bar" [ngStyle]="leftBarStyle">
        <div class="left-progress" [ngStyle]="leftProgressStyle"></div>
        <span class="low">{{ lowPoint }}</span>
        <span class="mid">{{ midPoint }}</span>
    </div>
    <div class="right-bar" [ngStyle]="rightBarStyle">
        <div class="right-progress" [ngStyle]="rightProgressStyle"></div>
        <span class="high">{{ highPoint }}</span>
    </div>
</section>
